<template>
    <div>
        <div class="title">
            <div>{{ $t("Bill.ResourceOptimization.title") }}</div>
        </div>
        <resource-optimization-search></resource-optimization-search>
    </div>
</template>
<script>
    import ResourceOptimizationSearch from '../resource_optimization/ResourceOptimizationSearch';
    export default {
        name: 'ResourceOptimization',
        components: {
            ResourceOptimizationSearch
        }
    }
</script>

<style scoped>
    .title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
</style>



// WEBPACK FOOTER //
// src/components/ebilling/resource_optimization/ResourceOptimization.vue